// types/auth.ts

// 로그인 요청 타입
export interface LoginRequestType {
    userId: string;
    password: string;
    rememberMe?: boolean;
}

// 로그인 응답 타입
export interface LoginResponseType {
    token: string;
    userId: string;
    name: string;
    adminGrade: AdminGrade;
}

// 현재 사용자 타입
export interface CurrentUserType {
    userId: string | null;
    userName: string | null;
    adminGrade: string | null;
    token: string | null;
}

// 관리자 등급 enum
export enum AdminGrade {
    최고운영자 = "최고운영자",
    운영자 = "운영자",
    부운영자 = "부운영자",
    일반관리자 = "일반관리자"
}